import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TermsUse = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Remove the # character
      const elementId = location.hash.substring(1);
      
      // Find the element with the matching ID
      const element = document.getElementById(elementId);
      
      // If found, scroll to it
      if (element) {
        // Use setTimeout to ensure the page has fully loaded
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);
  return (
    <>
      <div>
        <p>
          <br />
        </p>
        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Terms of Use
          </span>
        </h4>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            EMBIFI GLOBAL SERVICES PRIVATE LIMITED
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;is a company incorporated under the provisions of Companies
            Act, 2013, having its registered office at New Delhi, India
            (“Company”, “We”, “Us” , “Our”). The Company is engaged in the
            business of, inter alia, providing plug-in technology to enable
            facilitation of embedded finance/loans for businesses.&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            In connection therewith, subject to and on the Terms of Use (“ToU”)
            set out herein, we and/or our associated lending partners have
            agreed to provide the services and/or products availed by the
            Customer (“you”, “your”, “yourself”) through our embifi.in website
            (“website”, “platform” , “portal”) or in any manner
            whatsoever.&nbsp;
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "#ffffff",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            For the purposes of this ToU the term “Customer” shall mean any
            natural or legal person who accesses or uses the website and in the
            event that a natural person is representing a business entity or a
            body corporate, reference to such terms shall include a reference to
            such business entity and/or body corporate as well and other
            promoters of such business entity and/or body corporate. All
            references to “You” shall include yourself and any other persons you
            are authorised to and required to provide consent for.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <p
              dir="ltr"
              style={{
                lineHeight: "1.38",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "0pt",
                marginBottom: "0pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                General Terms
              </span>
            </p>
          </li>
        </ol>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            1.1 Access to and use of this Website is subject to these ToU and
            the Privacy Policy of the Company. By accessing and using this
            Website you agree to be bound by and to act in accordance with these
            ToU and our Privacy Policy. If you do not agree to these ToU or our
            Privacy Policy, you are not permitted to access and use this Website
            and you should cease such access and/or use immediately. If you
            breach any term of these ToU, your right to access and use this
            Website shall cease immediately.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            1.2 We reserve the right to amend these ToU from time to time
            without notice and it is strongly recommended that you periodically
            review our ToU as available on the Website. The amended ToU will be
            effective from the date they are posted on this Website. Your
            continued use of this Website will constitute your acceptance of the
            amended ToU.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "#ffffff",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            1.3 We may, upon receiving your consent, request certain third
            parties to provide information about you to further personalise Your
            experience on the portal, and provide certain services that cannot
            be accessed by all Customers of the portal. you acknowledge and
            consent to the fact some of your data may be shared by third parties
            and such data shall be stored, retained and otherwise used or
            utilised by Us in accordance with our Privacy Policy
          </span>
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={2}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <h4
              dir="ltr"
              style={{
                lineHeight: "1.54284",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "12pt",
                marginBottom: "2pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Eligibility
              </span>
            </h4>
          </li>
        </ol>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            2.1 You expressly acknowledge and agree that (i) you are a legal
            person (ii) you are capable of entering and authorised to enter into
            a legally binding agreement (iii) all the information, including but
            not limited to, particulars and details in relation to loan
            application you submit is accurate and truthful (iv) you will
            maintain the accuracy of such information (v) you hold an active
            Indian mobile number and bank account (vi) you will provide any
            additional documents to us or any of its partners as may be required
            from time to time.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={3}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <p
              dir="ltr"
              style={{
                lineHeight: "1.38",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "0pt",
                marginBottom: "0pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Right to use Personal/Contact Details
              </span>
            </p>
          </li>
        </ol>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            3.1 By making use of this Website and furnishing your
            personal/contact details, you hereby agree that you are interested
            in availing the products/services that you have selected. You hereby
            agree that we reserve the right to make your details available to
            any of our authorised members/agents or partners and you may be
            contacted by them for information through email, telephone and/or
            SMS. You agree to receive promotional materials and/or special
            offers from us through email or SMS.&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Please be aware that information provided on this Website is
            provided for general information purposes only and is provided so
            that you can avail the product and/or service that you feel is
            appropriate to meet your needs. In the event, any information
            provided by you on this Website is required to be revised or
            updated, please reach out to us on&nbsp;
          </span>
          <a href="mailto:support@embifi.in" style={{ textDecoration: "none" }}>
            <span
              style={{
                fontSize: "11pt",

                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              support@embifi.in
            </span>
          </a>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;.We shall revise or update such information as may be feasible
            to us, provided that we shall not be responsible for the
            authenticity or veracity of the information being supplied by you.
            You should always check the suitability, adequacy and
            appropriateness of the product and/or service that is of interest to
            you and it is your sole decision whether to obtain or refrain from
            obtaining any product and/or service.&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            We aim to provide uninterrupted access to this Website but we give
            no warranty as to the uninterrupted availability of this Website.
            You agree not to use the website for any purpose that is unlawful,
            illegal or forbidden by these ToU, or any local laws that might
            apply to you. We reserve the right to suspend, restrict or terminate
            your access to this Website at any time.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            3.2 You authorise and voluntarily give your consent to the Company
            to gain one time access (and its service providers and lending
            partners), for the following:&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (i) to obtain your name, address, telephone number, photograph along
            with supporting KYC (Know Your Customer) documents, bank account
            details, financial statements, signed security cheques and other
            such personal information required;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (ii) link and authenticate your Aadhar number to all its services of
            the Company and or/its lending partners as may be opened in the
            future in addition to those mentioned herein;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (iii) handling the information and verification/identification
            records as per applicable law: (i) for the purposes above, (ii) as
            well as for regulatory and legal reporting and filings and/or (iii)
            where required under applicable law (iv) authenticate your details
            with Aadhar based authentication system and hereby consent to and
            authorise the Company and/or its lending partners to retrieve your
            personal details from Unique Identification Authority of India
            (“UIDAI”) for Aadhar based authentication for the purpose of
            generation of E-sign, for registration of e-mandate and for
            validating your consent to the terms and conditions of the
            definitive agreements for the services of the Company and/or its
            lending partners
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            3.3 We reserve the right to add, amend, delete, edit, remove or
            modify any information, content, material or data displayed on this
            Website and without notice from time to time. At any time while
            availing the services provided by us, you have an option to withdraw
            your consent for the purpose of using your information. You
            understand that your consent is essential to availing the products
            and/or services, in the event that the Company requires your
            personal information again to fulfil any legal/regulatory
            requirement, an additional consent will be requested by the Company.
            You however are free to withdraw your consent by writing to us
            at&nbsp;
          </span>
          <a href="mailto:support@embifi.in" style={{ textDecoration: "none" }}>
            <span
              style={{
                fontSize: "11pt",

                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "underline",
                WebkitTextDecorationSkip: "none",
                textDecorationSkipInk: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              support@embifi.in
            </span>
          </a>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;. Upon receipt of your request, we shall have the option to
            not provide products and/or services for which the consent was
            sought. The information submitted by you however shall be retained
            by us in order to comply with applicable laws.
          </span>
        </p>
        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 0pt 0pt",
          }}
        >
          <br />
        </h4>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={4}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <h4
              dir="ltr"
              style={{
                lineHeight: "1.54284",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "12pt",
                marginBottom: "2pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Loan Amount/Interest Rates/Other Charges&nbsp;
              </span>
            </h4>
          </li>
        </ol>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              fontFamily: "Arial",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            4.1 You hereby understand and acknowledge that you will pay our
            associated lending partners, interest on the services and/or
            products availed by you in connection with this ToU and Privacy
            Policy. The rate of interest/processing fee/other charges applicable
            to such services and/or products will be determined at the sole and
            exclusive discretion of the associated lending partners from time to
            time depending upon consideration of any or combination of, but not
            limited to the following factors:&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (i) your profile, eligibility/qualifications, subvention, schemes,
            subsidies available, permitted deviations; (ii) your overall
            customer yield, nature and value of primary and collateral security,
            your past repayment track record, prevalent market trends on
            interest rates and charges, various other credit risk factors,
            individual customer level profitability&nbsp;
          </span>
        </p>
        <p>
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            4.2 Further, you hereby specifically acknowledge, undertake and
            confirm that (i) said rate of interest/processing fee and/or other
            charges have been duly informed and explained to you in a language
            understandable and known to you (ii)&nbsp;
          </span>
          <span
            style={{
              fontSize: "8pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            the rate of interest excludes any and all tax, toll, duties, levies,
            cess, or any other tax as may be imposed by the central government,
            state government, judicial, quasi-judicial or any municipal
            authorities, which may be payable additionally by you (iii) the
            interest shall be payable monthly on such due dates as specified by
            the associated lending partner; (iv) without limiting your
            obligation as above, the lending partner reserves the right to
            change/reset interest rates and communicate the same to you&nbsp;
          </span>
        </p>
        <p>
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            4.3 No disputes, whether actual, contingent or otherwise and whether
            between you and the lending partner or you and any third party
            and/or service provider shall entitle you, under any circumstance to
            withhold the payment of any outstanding balance including interest/
            processing fees/ amounts/charges/dues payable and timely payments by
            you being the essence of the services and/or products availed.&nbsp;
          </span>
        </p>
        <p>
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            4.4 Without prejudice to the lending partners rights and remedies
            under contract and/or law: in case of any breach by you of any of
            the ToU contained herein, including non-payment of outstanding
            balance and/or principal/interest/dues/ charges/ processing fees
            payable when due; you will be liable to pay default interest at the
            rate specified by the lending partner from time to time.&nbsp;
          </span>
        </p>
        <p>
          <br />
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={5}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <p
              dir="ltr"
              style={{
                lineHeight: "1.38",
                textAlign: "justify",
                marginTop: "0pt",
                marginBottom: "0pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Intellectual Property Rights and Confidentiality&nbsp;
              </span>
            </p>
          </li>
        </ol>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "11pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 15pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            5.1 You acknowledge and agree that we exclusively retain and/or own
            &nbsp;(i) all worldwide legal rights, titles and interests in and to
            the services, including but not any intellectual property rights
            which subsist in the services (whether those rights are registered
            or not, and wherever in the world those rights exist). (ii) you
            understand that you do not have the right to use any of our trade
            names, trademarks, service marks, logos, domain names, and other
            distinctive brand features (iii) you do not have the right to
            remove, obscure, or alter any proprietary rights notices (including
            trademark and copyright notices), which may be affixed to or
            contained within the services (iv) you will not copy, create a
            derivative work, modify, transmit or otherwise attempt to discover
            any source code of the services&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "15pt",
            padding: "-4pt 0pt 0pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            5.2 Each of the parties further acknowledge that, pursuant to this
            ToU, it may have
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "#ffffff",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;access to certain confidential information of the other party
            and accordingly, each receiving party agrees not to disclose to any
            third party any confidential information of the disclosing party.
          </span>
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={6}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <h4
              dir="ltr"
              style={{
                lineHeight: "1.54284",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "12pt",
                marginBottom: "2pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Limitation of Liability&nbsp;
              </span>
            </h4>
          </li>
        </ol>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "11pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 15pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            6.1 Notwithstanding anything to the contrary contained herein, the
            Company, its affiliates and their respective directors, officers,
            employees, agents and representatives shall have no liability to you
            or to any third party for any indirect, incidental, special or
            consequential damages or any loss of revenue or profits arising
            under or relating to this ToU.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "-4pt 0pt 15pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            6.2 The Company will not be liable to you for any loss or damage
            whatsoever or howsoever caused or arising, directly or indirectly,
            including without limitation, as a result of loss of data;
            interruption or stoppage to your access to and/or use of the
            company’s technology platform or services, hacking or unauthorised
            access to the Company’s technology platform, services,
            non-availability of connectivity between the Company site and the
            merchants, etc. Any material/information downloaded or otherwise
            obtained through the use of the Company’s technology platform or
            services is done at your own discretion and risk, and you will be
            solely responsible for any damage to your computer system or loss of
            data that results from the download of any such material. No advice
            or information, whether oral or written, obtained by you from the
            Company or through or from the use of services or the Company
            technology platform shall create any warranty, the Company shall
            have no liability in this respect. Although the Company adopts
            security measures it considers appropriate for the offer of its
            services through the website, it does not assure or guarantee that
            no person will overcome or subvert the security measures and gain
            unauthorised access to your account. The Company will not be
            responsible or liable if any unauthorised person hacks into or gains
            access to your account.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "15pt",
            padding: "-4pt 0pt 0pt 0pt",
          }}
        >
          <br />
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={7}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <h4
              dir="ltr"
              style={{
                lineHeight: "1.54284",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "12pt",
                marginBottom: "2pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Indemnification&nbsp;
              </span>
            </h4>
          </li>
        </ol>
        <p>
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "#ffffff",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            7.1 You undertake to accept and be solely liable for the services
            availed by you from the Company. You further undertake to indemnify
            and hold harmless the Company, its affiliates and their respective
            directors, officers, employees, agents and representatives against
            all damages suffered or losses incurred by the Company arising due
            to any act, omission or claim initiated by you or any third party in
            relation to the services availed by you or in case of breach of this
            ToU or any warranty by you.
          </span>
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={8}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <p
              dir="ltr"
              style={{
                lineHeight: "1.38",
                textAlign: "justify",
                marginTop: "0pt",
                marginBottom: "0pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "#ffffff",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Termination&nbsp;
              </span>
            </p>
          </li>
        </ol>
        <p>
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 12pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "#ffffff",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            8.1 You may terminate this ToU at any time by discontinuing any
            further use of the website or services thereof and provided that you
            contact us about the same at support@embifi.in. Upon account
            closure, we will cancel any pending transactions unless otherwise
            legally prohibited. However, any such termination shall not cancel
            your obligation to repay any loan and/or facility availed through a
            lending partner, or any other obligation which has accrued, or is
            unfulfilled and relates to the period, prior to termination. If you
            owe any payment to the Company or the lending partner, the Company
            will not close your account until that payment has been made, but
            the Company may limit your ability to make additional transactions
            using your account. You may not close your account to evade an
            investigation. The Company will retain Your information in
            accordance with these Terms and Our Privacy Policy.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "10pt 0pt 30pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "#ffffff",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            8.2 This ToU takes effect from the date of their publication on the
            website. We reserve the right to terminate the services in the event
            of breach of any terms contained in this ToU , misrepresentation of
            information, any unlawful activity by you or if we are unable to
            verify or authenticate any information submitted by you.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "30pt",
            padding: "-8pt 0pt 0pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "#ffffff",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            8.3 Notwithstanding anything contained in this ToU, if we reasonably
            believe that you are acting in breach of any of this ToU, in
            addition to our right to immediately suspend or terminate your
            account from the website, without any notice.
          </span>
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={9}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <h4
              dir="ltr"
              style={{
                lineHeight: "1.54284",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "12pt",
                marginBottom: "2pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Representation and Warranty
              </span>
            </h4>
          </li>
        </ol>
        <p
          dir="ltr"
          style={{ lineHeight: "1.38", marginTop: "0pt", marginBottom: "0pt" }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            9.1 You hereby represent and warrant that:&nbsp;
          </span>
        </p>
        <p>
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (i) all the particulars and information and details provided in the
            application form to avail the loan products and/or facility and
            documents given by you to us and/or our lending partners in
            connection therewith, are true, correct, accurate and up-to-date in
            all respects and that you have not withheld or suppressed any
            material information from the Company and/or its lending partners in
            this regard (ii) you are not barred or otherwise prohibited from
            accessing or using our website in any manner; (iii) if you choose to
            access the website from locations other than India, you shall do so
            at your own risk, and you would be solely liable and responsible for
            compliance with applicable local laws and regulations of such
            location/territory. We accept no liability whatsoever, direct, or
            indirect or consequential, for non-compliance with the laws of any
            country other than the Republic of India; (iv) you are solely liable
            for any impersonation or fraud that you may commit while submitting
            any information on this Website and the resultant damage or injury
            that such impersonation or fraud may cause to us or to any third
            party; (v) You ensure that you do not have any account in the name
            of individuals/entities appearing in the lists of individuals and
            entities, suspected of having terrorist links, which are approved by
            and periodically circulated by the United Nations Security Council
            (UNSC Sanctions Lists). The details of the two lists are available
            at <a href="https://scsanctions.un.org/ohz5jen-al-qaida.html" target="_blank">https://scsanctions.un.org/ohz5jen-al-qaida.html</a> and <a href="https://scsanctions.un.org/3ppp1en-taliban.htm" target="_blank">https://scsanctions.un.org/3ppp1en-taliban.htm </a>
            and the lists as available in the Schedules to the Prevention and
            Suppression of Terrorism (Implementation of Security Council
            Resolutions) Order, 2007, as amended from time to time.&nbsp;
          </span>
        </p>
        <p>
          <br />
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={10}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <p
              dir="ltr"
              style={{
                lineHeight: "1.38",
                textAlign: "justify",
                marginTop: "0pt",
                marginBottom: "0pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Company’s Disclaimers&nbsp;
              </span>
            </p>
          </li>
        </ol>
        <p>
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "#ffffff",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            10.1 Except as expressly provided herein, we disclaim all
            warranties, responsibilities, express or implied, written or oral,
            including but not limited towards warranties of merchantability, any
            service interruptions (including on account of communication
            outages, system failures or other interruptions that may affect the
            receipt, processing, acceptance, completion or settlement of
            transactions) and fitness of the Company’s services and it does not
            warrant that the functions contained in our services shall be
            uninterrupted or error free.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={11}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <h4
              dir="ltr"
              style={{
                lineHeight: "1.54284",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "12pt",
                marginBottom: "2pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Grievance Redressal&nbsp;
              </span>
            </h4>
          </li>
        </ol>
        <p>
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            11.1 We aim to resolve your complaints and/or issues in a timely
            manner. You may e-mail the same at support@embifi.in and we will aim
            to address your concerns arising out of our services and/or products
            or acts relating to the use of the website within 10 business days.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            11.2 If you remain dissatisfied with our response you may contact
            the designated Grievance Officer of the Company at:
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "12pt",
            marginBottom: "12pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Name: Gaurav Parashar&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "12pt",
            marginBottom: "12pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Address: 603-604, 6th Floor, Thapar House, Building No. N161
            Gulmohar Enclave Community Centre, Near Green park metro station New
            Delhi 110016
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "12pt",
            marginBottom: "12pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Phone: +91 8448559088
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "12pt",
            marginBottom: "12pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Email: compliance@embifi.in&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            marginTop: "12pt",
            marginBottom: "12pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            [10:00 AM to 5:00 PM, Monday to Friday, except Public Holidays]
          </span>
        </p>
        <ol
          style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}
          start={12}
        >
          <li
            dir="ltr"
            style={{
              listStyleType: "decimal",
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
            aria-level={1}
          >
            <h4
              dir="ltr"
              style={{
                lineHeight: "1.54284",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                marginTop: "12pt",
                marginBottom: "2pt",
              }}
            >
              <span
                style={{
                  fontSize: "11pt",

                  color: "#000000",
                  backgroundColor: "transparent",
                  fontWeight: 700,
                  fontStyle: "normal",
                  fontVariant: "normal",
                  textDecoration: "none",
                  verticalAlign: "baseline",
                  whiteSpace: "pre-wrap",
                }}
              >
                Miscellaneous
              </span>
            </h4>
          </li>
        </ol>
        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.1 Dispute Resolution and Governing Law
          </span>
        </h4>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            10.1.1 These ToU and your access to and use of this website shall be
            governed by and interpreted in accordance with Indian laws.&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.1.2 If any dispute arises between us and you in connection with
            or arising out of the validity, interpretation, implementation or
            alleged breach of any provision of these ToU, such dispute, if not
            amicably settled within 30 (thirty) business days, shall be referred
            to and finally resolved by arbitration in accordance with the Indian
            Arbitration and Conciliation Act, 1996 for the time being in force.
            The dispute shall be resolved through arbitration by 1 (one)
            arbitrator and the seat of the arbitration shall be New Delhi,
            India.&nbsp;
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.1.3 Each party shall bear its own cost of arbitration&nbsp;
          </span>
        </p>
        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.2 Survival Of Terms
          </span>
        </h4>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.2.1 Notwithstanding any other provisions of this ToU, or any
            general legal principles to the contrary, any provision of this ToU
            that imposes or contemplates continuing obligations on a party will
            survive the expiration or Termination of this ToU
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "22pt 0pt 30pt 0pt",
          }}
        >
          <br />
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "-8pt 0pt 30pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.3 Assignment
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            <br />
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.3.1&nbsp;
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            These ToU, or any right or interest herein, shall not be assignable
            or transferable by you without the prior written consent of the
            Company. Rights and obligations of the Company under these ToU are
            freely assignable without your prior written consent.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "-8pt 0pt 30pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.4 Force Majeure
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            <br />
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.4.1&nbsp;
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            The Company shall not be liable for any failure to perform any of
            its obligations under the ToU or provide the services or any part
            thereof if the performance is prevented, hindered or delayed by a
            Force Majeure Event (defined below) and in such case its obligations
            shall be suspended for so long as the Force Majeure Event continues.
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            <br />
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            "Force Majeure Event"
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;means any event due to any cause beyond the reasonable control
            of the Company, including, without limitation, unavailability of any
            communication system, breach or virus in the systems, fire,
            pandemic, flood, explosion, acts of God, civil commotion, riots,
            insurrection, war, acts of government
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "-8pt 0pt 30pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.5 Entire Agreement
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            <br />
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.5.1&nbsp;
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            The ToU along with the Privacy Policy constitute the entire
            agreement between the Company and you and supersede and extinguish
            all previous agreements, promises, assurances, representations,
            warranties and undertakings, whether written or oral.
          </span>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "30pt",
            padding: "-8pt 0pt 0pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.6 Severability
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            <br />
          </span>
          <span
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.6.1&nbsp;
          </span>
          <span id="cancellation-refund-policy"
            style={{
              fontSize: "11pt",

              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            If any provision of the ToU is determined to be invalid or
            unenforceable in whole or in part, such invalidity or
            unenforceability shall attach only to such provision or part of such
            provision and the remaining part of such provision and all other
            provisions of the ToU shall continue to be in full force and effect.
          </span>
        </p>
        <section >
        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "center",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "20pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            13. Cancellation and Refund Policy
          </span>
        </h4>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            At EMBIFI, we strive to provide a seamless rental experience for our customers. 
            Please read our cancellation and refund policy to understand your rights and 
            responsibilities when booking and renting an electric vehicle from us.
          </span>
        </p>

        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            13.1 No Refund After Payment
          </span>
        </h4>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Once payment has been made for the advance rented vehicle, no refunds will be issued for:
          </span>
        </p>

        <ul style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Cancellations
            </span>
          </li>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Early returns
            </span>
          </li>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Unused rental days
            </span>
          </li>
        </ul>

        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            13.2 Refund for Vehicle Unavailability
          </span>
        </h4>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            A refund will only be issued if the rented vehicle is not available for pickup from the designated hub at the scheduled time. In such cases, we will:
          </span>
        </p>

        <ul style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Work with you to reschedule the rental
            </span>
          </li>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Issue a refund for the booking
            </span>
          </li>
        </ul>

        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            13.3 Security Deposit Refund
          </span>
        </h4>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            The security deposit paid at the time of vehicle pickup will be refunded after the rental period has ended, subject to the following conditions:
          </span>
        </p>

        <ul style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The vehicle is returned in the same condition as it was rented, without any damages beyond normal wear and tear.
            </span>
          </li>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              All rental fees, additional charges, and fines have been settled in full.
            </span>
          </li>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The refund process may take up to 7 business days to complete from the vehicle return date.
            </span>
          </li>
        </ul>

        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            13.4 Damage Assessment
          </span>
        </h4>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Prior to refunding the security deposit, our team will:
          </span>
        </p>

        <ul style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Assess the rented vehicle for any damages or excessive wear
            </span>
          </li>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Deduct any damages that exceed normal wear and tear from the security deposit before issuing the refund
            </span>
          </li>
        </ul>

        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            13.5 Refund Process
          </span>
        </h4>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Refunds will be issued to the original payment method used for the rental booking.
            You will receive a confirmation once the refund has been processed, detailing:
          </span>
        </p>

        <ul style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: "48px" }}>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              The refund amount
            </span>
          </li>
          <li
            dir="ltr"
            style={{
              listStyleType: "disc",
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre",
            }}
          >
            <span
              style={{
                fontSize: "11pt",
                color: "#000000",
                backgroundColor: "transparent",
                fontWeight: 400,
                fontStyle: "normal",
                fontVariant: "normal",
                textDecoration: "none",
                verticalAlign: "baseline",
                whiteSpace: "pre-wrap",
              }}
            >
              Any deductions made
            </span>
          </li>
        </ul>

        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            13.6 Changes and Cancellations
          </span>
        </h4>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            If you need to change or cancel your booking, please notify us as soon as possible.
            We will discuss the available options with you.
            Changes to booking dates or rental duration may be accommodated based on availability and our discretion.
          </span>
        </p>

        <h4
          dir="ltr"
          style={{
            lineHeight: "1.54284",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "12pt",
            marginBottom: "2pt",
            padding: "12pt 0pt 2pt 0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            13.7 Contact Us
          </span>
        </h4>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            If you have any questions or concerns regarding our cancellation and refund policy, please contact us:
          </span>
        </p>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "medium",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Email: support@embifi.in
          </span>
        </p>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            By booking and renting an electric vehicle from EMBIFI, you agree to comply with the terms of our cancellation and refund policy. We appreciate your understanding and cooperation in ensuring a smooth rental experience.
          </span>
        </p>

        <p
          dir="ltr"
          style={{
            lineHeight: "1.38",
            textAlign: "justify",
            backgroundColor: "#ffffff",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <span
            style={{
              fontSize: "11pt",
              color: "#000000",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Thank you for choosing EMBIFI for your electric vehicle rental needs.
          </span>
        </p>
        </section>
      </div>
    </>
  );
};

export default TermsUse;
